
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';

export default {
  
  mixins: [eventTrackingMixins],

  data() {
    return {
      componentRendered: false,
      promotionBannerLoadedCount: 0,
    };
  },
  
  computed: {
  },
  created() {
  },
  mounted() {
    this.setEventTrackingListenersForFamilySiteProductCards()
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeUpdate() {
  },
  updated() {
  },

  methods: {
  
    initEventTrackingParams() {
      return {
        a: '',
        c: '',
        l: '',
        cd: {
          login_status: this.loginBoolean,
        },
      };
    },

    setEventTrackingListenersForFamilySiteProductCards() {
      this.eventTrackingListenersForFamilySiteProductCards()
    },


    eventTrackingListenersForFamilySiteProductCards() {
      const item = document.querySelectorAll('.product-section a, .happy-kids-home-page-product-section a');

      if (item) {
        const self = this
        item.forEach(function (el) {
          if (el.getAttribute('data-listener') === null) {
            el.setAttribute('data-listener', 'true')
            el.addEventListener('click', self.handleEventTracking_familySiteProductCards);
          }
        });
      }
    },

    handleEventTracking_familySiteProductCards(event) {
      event.preventDefault();
      let selector;
      if (event.target.closest('.happy-kids-home-page-product-section .item') !== null) {
        selector = '.happy-kids-home-page-product-section .item'
      } else {
        selector = '.product-section .item'
      }
      const dataFromClickableElement = this.extractDataFromClickedElement(event.target, selector)
      const href = dataFromClickableElement?.href
      const eventTrackingParams = this.initEventTrackingParams()


      // #235 click cta and redirect to certified product page.
      if (this.isFamilySiteProductPageLink(href)) {
        console.log('#235 isFamilySiteProductPageLink')
        const linkText = dataFromClickableElement?.link_text
        
        eventTrackingParams.a = 'to_certifiedproductpage'
        eventTrackingParams.l = linkText 
        eventTrackingParams.c = `family_site_product_card_cta`
        eventTrackingParams.cd.product_category = `${dataFromClickableElement.card_category}`
        eventTrackingParams.cd.product_name = `${dataFromClickableElement.card_title}`
        eventTrackingParams.cd.insurer_name = `${dataFromClickableElement.insurer_name}`
        if(eventTrackingParams.a !== ''){
          this.sendEventTracking(eventTrackingParams)
        }
      }
      
      // #236
      if (dataFromClickableElement.offsetparent_node.attributes["data-ref-code"]?.value.startsWith('high-cp')) {
        // console.log('feature tag high-cp')
        const linkText = dataFromClickableElement?.link_text
        
        eventTrackingParams.a = 'to_happykids_methodology'
        eventTrackingParams.l = linkText 
        eventTrackingParams.c = `family_site_product_card_cp_value`
        eventTrackingParams.cd.product_category = `${dataFromClickableElement.card_category}`
        eventTrackingParams.cd.product_name = `${dataFromClickableElement.card_title}`
        eventTrackingParams.cd.insurer_name = `${dataFromClickableElement.insurer_name}`
        if(eventTrackingParams.a !== ''){
          this.sendEventTracking(eventTrackingParams)
        }
      }

      // #237
      if (dataFromClickableElement.offsetparent_node.attributes["data-ref-code"]?.value.startsWith('high-coverage')) {
        console.debug('#237: feature tag high-coverage')
        const linkText = dataFromClickableElement?.link_text
        
        eventTrackingParams.a = 'to_happykids_methodology'
        eventTrackingParams.l = linkText 
        eventTrackingParams.c = `family_site_product_card_high_coverage`
        eventTrackingParams.cd.product_category = `${dataFromClickableElement.card_category}`
        eventTrackingParams.cd.product_name = `${dataFromClickableElement.card_title}`
        eventTrackingParams.cd.insurer_name = `${dataFromClickableElement.insurer_name}`
        if(eventTrackingParams.a !== ''){
          this.sendEventTracking(eventTrackingParams)
        }
      }


      // #244 the action leads to decoder product details page.
      if (this.isProductDetailLink(href)) {
        console.debug('#244 isProductDetailLink')
        const linkText = dataFromClickableElement?.link_text
        
        eventTrackingParams.a = 'open_product_details'
        eventTrackingParams.l = linkText 
        eventTrackingParams.c = `family_site_product_card_cta`
        eventTrackingParams.cd.product_category = `${dataFromClickableElement.card_category}`
        eventTrackingParams.cd.product_name = `${dataFromClickableElement.card_title}`
        eventTrackingParams.cd.insurer_name = `${dataFromClickableElement.insurer_name}`
        if(eventTrackingParams.a !== ''){
          this.sendEventTracking(eventTrackingParams)
        }
      }

    },

    
    // #234 the insurer product card impression. ad_impression family_site_product_card
    handleEventTracking_familySiteProductCardVisible(insurerCode, productName) {
      const eventTrackingParams = this.initEventTrackingParams()
      eventTrackingParams.a = 'ad_impression'
      eventTrackingParams.l = `${productName}`
      eventTrackingParams.c = `family_site_product_card`
      eventTrackingParams.cd.product_category = ``
      eventTrackingParams.cd.product_name = productName
      eventTrackingParams.cd.insurer_name = `${insurerCode}`
      if(eventTrackingParams.a !== ''){
        this.sendEventTracking(eventTrackingParams)
      }
    },

  
    isFamilySiteProductPageLink(link) {
      const href = link;
      if (!href) return false;

      const patternProducts = /^.*\/([a-zA-Z0-9%\-]+)-product-([a-zA-Z0-9%\-]+)$/;
      if (href.match(patternProducts)) {
        return true;
      }
      return false;
    },

    isFamilySiteHomePageLink(link) {
      const href = link;
      if (!href) return false;

      const patternProducts = /^.*\/([a-zA-Z0-9%\-]+)-([0-9]+)$/;
      if (href.match(patternProducts)) {
        console.log('isFamilySiteHomePageLink')
        return true;
      }
      return false;
    }
    

  },
  
};